import Vue from 'vue'
import { mapState } from 'vuex'

// configs
import configs from '@/config'

// utils
import utils from '@/util'

export default (component) => Vue.component('LastSlideContainer', {
  data() {
    return {
      presenterUrl: '',
      isWhiteLabelUser: false,
    }
  },
  computed: {
    ...mapState({
      slide: (state) => state.slide,
      presentation: (state) => state.presentation,
    }),
  },
  mounted() {
    if (window.location.host !== configs.domain) {
      this.isWhiteLabelUser = true
    }
    this.presenterUrl = `${configs.presenterUrl}/pages/register?source=presentation_${this.presentation.id}&medium=audience_app&campaign=end_of_presentation_cta&content=${this.slide.type}`
  },
  methods: {
    handleClickOnButtonCTA() {
      const campaign = this.slide.type === 'leaderboard' ? 'leaderboard_CTA' : 'question_CTA'
      window.open(utils.generateButtonCTAURL(this.presentation.id, this.slide, campaign), '_blank')
      utils.trackGAButtonCTA(this.presentation.id, this.slide)
    },
    handleExitPresentation() {
      window.location.href = window.location.origin
    },

  },
  render(createElement) {
    if (!this.slide.id) return null
    return createElement(component, {
      props: {
        ...this.$attrs,
        presenterUrl: this.presenterUrl,
        isWhiteLabelUser: this.isWhiteLabelUser,
        handleClickOnButtonCTA: this.handleClickOnButtonCTA,
        handleExitPresentation: this.handleExitPresentation,
        isQnaAllSlides: this.presentation.qnaAllSlide,
        showAhaSlidesCTA: this.presentation.showAhaSlidesCTA,
      },
    })
  },
})
